import { Dispatch } from "redux";
import { sendAxnAdminUserInvitationRequest } from "@requests/axnadmin-core";
import { AxnAdminUserPropertyBundle } from "@idw-types/data/axn-admin-user-property-bundle";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { getOrganizationInvitationsReduxRequest } from "./get-organization-invitations";
import { RpUserPropertyBundle } from "@idw-types/data/axn-admin-user/rp-user-property-bundle";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { RelyingPartyRole } from "@idw-types/common";

// todo - need to look more into this one for error handling as the underlying request is odd
export const sendUserInvitationReduxRequest = (dispatch: Dispatch) => async (
    email: string,
    axnCompany: AxnCompany,
    organizationRole: AxnAdminUserPropertyBundle,
    relyingPartyRoles: Array<RelyingPartyRole>,
    shouldReloadInvitations: boolean,
    axnAdminUserPropertyBundles: Array<AxnAdminUserPropertyBundle>,
    axnCompanies: Array<AxnCompany>,
    axnRelyingParties: Array<AxnRelyingParty>
) => {

    const rpUserPropertyBundles: Array<RpUserPropertyBundle> = relyingPartyRoles.map(rpr => ({
        relyingPartyID: parseInt(rpr.relyingParty.id),
        userPropertyBundleID: parseInt(rpr.bundle.id)
    }));

    const { data, error, body } = await sendAxnAdminUserInvitationRequest(
        email,
        axnCompany.id,
        organizationRole?.id,
        rpUserPropertyBundles
    );

    if (data?.response) {
        // todo - this should be unneccessary if we receive the invitation in the previous response
        displaySuccessModal(
            dispatch,
            resources.requests.sendAxnAdminUserInvitation.success.title,
            resources.requests.sendAxnAdminUserInvitation.success.message(email)
        );
        if (shouldReloadInvitations) {
            await getOrganizationInvitationsReduxRequest(dispatch)(axnAdminUserPropertyBundles, axnCompanies, axnRelyingParties);
        }
        return data;
    }
    else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.sendAxnAdminUserInvitation.error.title,
            resources.requests.sendAxnAdminUserInvitation.error.message,
            error,
            null,
            body
        );
    }

    return null;
};